import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://ecard.link/",
});

export default axiosInstance;  